import React from 'react';

import DepositContentHiPay from './methods/hipay';
import { DepositContentOctopay } from './methods/octopay';
import DepositContentPix from './methods/pix';
import DepositContentPixSafeway from './methods/pixSafeway';

import './style.scss';

const popupContentMap = {
  hipay: DepositContentHiPay,
  pix: DepositContentPix,
  'pix-safeway': DepositContentPixSafeway,
  pix_safeway: DepositContentPixSafeway,
  octopay: DepositContentOctopay
};

const DepositPopup = ({ type }) => {
  const Content = popupContentMap[type];
  return Content ? <Content type={type} /> : null;
};

export default DepositPopup;
